import { IApplicationState } from '../../types/redux';

export const selectNotifications = (state: IApplicationState) => {
  return state.notifications;
};
